<div class="delivery--container">
    <ng-container *ngTemplateOutlet="(readonly || !canOrder)? readOnlyTemplate : editableTemplate ">
    </ng-container>
</div>


<ng-template #editableTemplate>
    <div [ngClass]="{'line-separator--light-grey mb-3': isLastShipment && !canAddAnotherAddress}" class="pb-3">
        <ng-container *ngIf="delivery && product">
            <ng-container *ngIf="{ outOfStock: isOutOfStock$ | async } as vm">

                <app-customization-control *ngIf="!product.hasVariations" [order]="order"
                                           [orderItem]="orderItem"
                                           [orderItemDelivery]="delivery"
                                           (onUpdate)="handleCustomizationChanged($event)"></app-customization-control>

                <div class="edit-delivery--row"
                     [ngClass]="{'list-item': viewType === 'list-item'}">

                  <div class="grid-col-1--tablet" [class.col-hidden]="hasVariations">
                    <div class="grid-col-1" [class.col-hidden]="hasVariations" >
                      <div class="delivery-quantity" *ngIf="!product.hasVariations">
                        <div class="label color--primary-grey" *ngIf="_showInputLabel">Qty Per Address</div>
                        <div class="full-width">

                          <input class="m-0"
                                 (change)="onQuantityChanged($event)"
                                 (blur)="onQuantityBlur()"
                                 [min]="0"  digitOnly type="number"
                                 [value]="delivery.quantity"
                                 [disabled]="isFieldDisabled(vm.outOfStock)"
                                 [readonly]="isItemCut"
                          />

                        </div>
                      </div>
                    </div>
                  </div>


                  <!--  on-demand inventory allocation control-->
                  <div class="grid-col-2" [class.col-hidden]="hideOnDemandAllocationControl">
                    <app-on-demand-inventory-allocation-control
                      [orderItem]="orderItem"
                      [disabled] = "isFieldDisabled(vm.outOfStock)"
                      [delivery]="delivery"
                      (onSelectAllocationGroup)="handleUpdateInventoryAllocation($event)">
                    </app-on-demand-inventory-allocation-control>
                  </div>

                  <!--Delivery Address-->
                  <div class="grid-col-3">
                    <div class="delivery-address">
                      <div class="label color--primary-grey" *ngIf="_showInputLabel">Ship-To Address
                        <span *ngIf="showEudrWarning" title="EUDR restriction applies" class="warning-icon pr-2">
                            <i class="fas fa-exclamation-circle text-warning"></i>
                        </span>
                      </div>
                      <app-ship-to-address [isInline]="true"
                                           [order]="order"
                                           [delivery]="delivery"
                                           [orderItem]="orderItem"
                                           (addressSelected)="updateAddressData($event)"
                                           (eudrRestrictionChanged)="onEudrRestrictionChanged()"
                                           [disabled]="isFieldDisabled(vm.outOfStock)" >
                      </app-ship-to-address>

                    </div>
                  </div>

                  <!--buying window allocation group control -->
                  <div class="grid-col-4" [class.col-hidden]="hideBuyingWindowAllocationControl" >
                    <app-allocation-group-control
                      [orderItem]="orderItem"
                      [delivery]="delivery"
                      (onSelectAllocationGroupId)="handleUpdateAllocationGroup($event)">
                    </app-allocation-group-control>
                  </div>

                  <div class="grid-col-5">
                    <div class="delivery--shipping-method" >
                      <div  class="label color--primary-grey" *ngIf="_showInputLabel">{{ mobile ? 'Shipping' : 'Shipping Method'}}</div>
                      <ng-container *ngIf="isSingleShippingMethod && !delivery.is_uneligible">
                        <div class='shipping-method--wrapper'>
                          <span>{{findMethodLabel(product, delivery)}}</span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="!isSingleShippingMethod && !delivery.is_uneligible">
                        <ng-select class="ng-select--custom ng-select--width-constrained"
                          [items]="shippingMethods"
                          bindValue="method"
                          [searchable]="false"
                          (change)="updateShippingMethod($event)"
                          [clearable]="false"
                          [(ngModel)]="delivery.method"
                          [disabled]="isFieldDisabled(vm.outOfStock)"
                          placeholder="Select Method"
                          dropdownPosition="bottom">
                          <ng-template ng-label-tmp let-item="item">
                            <span class="font-5 grey">{{ item.method_label }}</span>
                          </ng-template>
                          <ng-template ng-option-tmp let-item="item">
                            <span class="font-5">{{ item.method_label }}</span>
                          </ng-template>
                        </ng-select>
                      </ng-container>
                      <ng-container *ngIf="delivery.is_uneligible">
                        <span style="line-height: 3">Not Eligible &nbsp;<button class="btn btn-icon" (click)="showDPFaqDialog()"><i class="fas fa-exclamation-circle"></i></button></span>
                      </ng-container>
                    </div>
                  </div>

                  <div class="grid-col-6" [class.col-hidden]="!canShowInternalOrder">
                    <div class="delivery--wbs" *ngIf="canShowInternalOrder">
                      <div class="label color--primary-grey" *ngIf="_showInputLabel">{{internalOrderLabel}}</div>
                      <div class="full-width">
                        <app-internal-order-code [order]="order"  [orderItem]="orderItem" [delivery]="delivery" [disabled]="isFieldDisabled(vm.outOfStock)">
                        </app-internal-order-code>
                      </div>
                    </div>
                  </div>


<!--                    <div *ngIf="showTotalInline" class="col col-2 px-3 flex-line" [ngClass]="{'list-item': viewType === 'list-item'}">-->
<!--                        <div *ngIf="isLastShipment">-->
<!--                            <strong class="price"><app-currency-price [price]="totals" [currency]="product.currency"  ></app-currency-price></strong>-->
<!--                            <span>SubTotal</span>-->
<!--                        </div>-->
<!--                    </div>-->

                  <div class="grid-col-7" [class.col-hidden]="!hasDiscountCodes">
                    <div *ngIf="hasDiscountCodes" class="delivery--discount" >
                      <div class="label color--primary-grey" *ngIf="_showInputLabel">Discount Code</div>
                      <ng-select
                        class="ng-select--custom ng-select--width-constrained"
                        [ngClass]="{'ng-select--error': $safeNavigationMigration(_selectedDiscountCode?.error_message)}"
                        [items]="_discountCodes"
                        bindValue="id"
                        bindLabel="code"
                        [searchable]="false"
                        (change)="updateDiscountCode($event)"
                        [clearable]="false"
                        [(ngModel)]="_selectedDiscountCodeId"
                        [disabled]="isFieldDisabled(vm.outOfStock)"
                        placeholder="Select discount code"
                        dropdownPosition="bottom">
                      </ng-select>
                      <div *ngIf="_selectedDiscountCode?.error_message" class="d-flex gap-2 font-6  font-weight-bold red text-uppercase">
                        <span>{{_selectedDiscountCode?.error_message}}</span>
                        <button class="reset-button font-6 font-weight-bold" (click)="resetDiscount()">CLEAR</button>
                      </div>
                    </div>
                  </div>

                </div>


                <div *ngIf="canRemoveAddress" class="col-12">
                    <strong class="delivery--row-remove"  (click)="removeAddress()">Remove</strong>
                </div>

            </ng-container>


        </ng-container>

    </div>


</ng-template>


<ng-template #readOnlyTemplate>
    <ng-container *ngIf="delivery.quantity > 0">
      <!-- First row-->
      <div class="delivery--row  readonly align-items-start">

          <div class="delivery-quantity layout">
                <div class="qty--inner">
                    <div class="label color--primary-grey" >Quantity</div>
                    <div class="d-flex flex-column align-items-center" [ngClass]="{'strikethrough' : isItemCut}">
                        <strong>{{ paidQuantity ? paidQuantity :  delivery.quantity }}</strong>
                    </div>
                </div>
                <app-customization-control [order]="order"
                                           [orderItem]="orderItem"
                                           [orderItemDelivery]="delivery"
                                            [readonly]="true"></app-customization-control>
            </div>


          <!--  on-demand inventory allocation control-->
          <ng-container *ngIf="!hideOnDemandAllocationControl">
            <app-on-demand-inventory-allocation-control
              [orderItem]="orderItem"
              [delivery]="delivery"
              [readonly]="true">
            </app-on-demand-inventory-allocation-control>
          </ng-container>



          <div class="delivery-address layout">
                <div class="label color--primary-grey">
                    Ship-To Address
                    <span *ngIf="showReadonlyEudrWarning" title="EUDR restriction applies" class="warning-icon pr-2">
                        <i class="fas fa-exclamation-circle text-warning"></i>
                    </span>
                </div>
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center">
                        <strong class="text-break-all">{{ getShipToLabel(delivery) }}</strong>&nbsp;
                        <ng-container *ngIf="showEditContactButton">
                            <button class="btn btn-icon ml-2" (click)="editContactDetails(delivery)"
                                    *ngIf="canEditDeliveryTo" ><i class="fal fa-edit"></i></button>
                        </ng-container>
                        <div *ngIf="showHiddenEditContactButton" ngbTooltip="This data cannot be edited" placement="top" class="ml-2">
                          <i class="fal fa-edit disabled"></i>
                        </div>
                    </div>
                    <span class="text-break-all">{{ delivery.street_1 }}</span>
                    <span class="text-break-all">{{ delivery.getCSZ() }}</span>
                </div>
            </div>

            <!--Buying window allocation group control-->
            <app-allocation-group-control
                    [orderItem]="orderItem"
                    [delivery]="delivery"
                    [readonly]="true">
            </app-allocation-group-control>

            <div class="delivery--shipping-method layout">
                <div class="label color--primary-grey" >Shipping</div>
                <div class="flex flex-column">
                    <div>
                        <strong>{{ findMethodLabel(product, delivery) }}</strong>
                    </div>
                    <div>
                        <span>Status: {{ delivery.status | translate }}</span>
                    </div>
                    <ng-container *ngIf="!showTrackingInfo && completed">
                        <div *ngIf="delivery.tracking_number">
                            <app-tracking-data [trackingData]="delivery.tracking_number"></app-tracking-data>
                        </div>
                    </ng-container>
                </div>
            </div>

        <div *ngIf="canShowInternalOrder" class="delivery--wbs layout">
          <div class="label color--primary-grey">{{internalOrderLabel}}</div>
          <div *ngIf="!showTrackingInfo" class="full-width">
            <app-internal-order-code
              [order]="order"
              [orderItem]="orderItem"
              [disabled]="!canPurchase"
              [delivery]="delivery"
              [readonly]="!showEditControls"
              [showWithModalDialog]="true"
              [shouldUpdateOrder]="true">
            </app-internal-order-code>
          </div>
          <div *ngIf="showTrackingInfo">
            <strong class="text-break-all">{{delivery.internalOrder || order.internalOrder}}</strong>
          </div>
        </div>

        <ng-container *ngIf="hasDiscountCodes">

          <!--   Can edit  discounts-->
          <div class="discount--wrapper" *ngIf="canEditDiscountCodes">
            <div class="delivery--discount">
              <div class="label color--primary-grey">Discount Code</div>
              <div class="full-width">
                <ng-select
                  class="ng-select--custom ng-select--width-constrained"
                  [ngClass]="{'ng-select--error': $safeNavigationMigration(_selectedDiscountCode?.error_message)}"
                  [items]="_discountCodes"
                  bindValue="id"
                  bindLabel="code"
                  [searchable]="false"
                  (change)="updateDiscountCode($event)"
                  [(ngModel)]="_selectedDiscountCodeId"
                  [disabled]="!canPurchase || isItemCut"
                  placeholder="Select discount code"
                  dropdownPosition="bottom">
                </ng-select>
                <div *ngIf="_selectedDiscountCode?.error_message" class="d-flex gap-2 font-6  font-weight-bold red text-uppercase">
                  <span>{{_selectedDiscountCode?.error_message}}</span>
                  <button class="reset-button font-6 font-weight-bold" (click)="resetDiscount()">CLEAR</button>
                </div>
              </div>
            </div>


            <div class="delivery--discount__value">
              <div class="label color--primary-grey">Discount</div>
              <span class="full-width font-weight-bold with-padding" [ngClass]="{'discount-error' : $safeNavigationMigration(_selectedDiscountCode?.error_message)}">
                {{_selectedDiscountCode?.discount}}
              </span>
            </div>
          </div>


          <!--  Cannot edit discounts, show readonly view-->
          <div class="d-flex" *ngIf="!canEditDiscountCodes">
            <div class="delivery--discount readonly" *ngIf="hasDiscountCode">
              <div class="label color--primary-grey">Discount Code</div>
              <span class="full-width font-weight-bold" [ngClass]="{'discount-error' : $safeNavigationMigration(_selectedDiscountCode?.error_message)}">
                {{_selectedDiscountCode?.code}}
              </span>
            </div>


            <div class="delivery--discount__value readonly" *ngIf="hasDiscountValue">
              <div class="label color--primary-grey">Discount</div>
              <span class="full-width font-weight-bold" [ngClass]="{'discount-error' : $safeNavigationMigration(_selectedDiscountCode?.error_message)}">
                {{_selectedDiscountCode?.discount}}
              </span>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="showTrackingInfo">


          <div class="delivery--tracking-info layout">
            <div class="label color--primary-grey">Tracking</div>
            <div class="order-item--shipping" [ngClass]="{'tracking--loader': _refreshingTrackingStatus}">
              <app-delivery-tracking [vendor]="orderItem.vendor"
                                     [orderState]="order.state"
                                     [delivery]="delivery"></app-delivery-tracking>
            </div>
          </div>

          <div class="delivery--shipped_qty layout" *ngIf="shippedQuantity" [ngClass]="{'tracking--loader': _refreshingTrackingStatus}">
            <div class="label color--primary-grey">Shipped Quantity</div>
            <div><strong>{{shippedQuantity}}</strong></div>

          </div>
          <div class="delivery--shipped_date layout" *ngIf="shippedDate" [ngClass]="{'tracking--loader': _refreshingTrackingStatus}">
            <div class="label color--primary-grey">Shipped Date</div>
            <div><strong>{{shippedDate | dateFormat}}</strong></div>

          </div>

        </ng-container>

        </div>
    </ng-container>

    <div *ngIf="product.hasVariations" class="variation--container">
        <div class="font-5 font-weight-bold mt-3 py-1 line-up-separator--grey  variation--container__header">
          <div class="label">Variations</div>
          <div *ngIf="ondemandProductHasInventoryAllocations" class="allocation">Allocation Group</div>
          <div class="price">Price Per Unit</div>
          <div class="qty text-center">Quantity</div>
          <div class="total">Total</div>
        </div>
         <div *ngFor="let sku of orderedSkus(); let i = index" class="py-1 line-up-separator--grey font-5  variation--container__content">
            <div class="label">
                <div class="variation--label">
                  <div class="label">Variations</div>
                </div>
                <div>
                  <div>{{getVariationLabel(sku)}}</div>
                  <ng-container *ngIf="getVariationUrn(sku) as urn">URN: {{urn}}</ng-container>
                  <ng-container *ngIf="getVariationCodeInfo(sku) as codeInfo">
                    <div>{{codeInfo.label}}: {{codeInfo.value}}</div>
                  </ng-container>
                </div>
            </div>

           <div *ngIf="ondemandProductHasInventoryAllocations" class="allocation">
             <div class="variation--label">
               <div class="label">Allocation Group</div>
             </div>
             <div class="text-break-word">
               {{getAllocationGroupLabelBySkuId(sku.sku_id)}}
             </div>
           </div>


           <div class="price">
             <div class="variation--label">
               <div class="label">Price Per Unit</div>
             </div>
             <div>
                <span class="price font-weight-normal">
                    <app-product-order-item-price [sku]="getProductSku(sku)" [orderItem]="orderItem"></app-product-order-item-price>
                </span>
             </div>
           </div>

            <div class="qty">
              <div class="variation--label">
                <div class="label">Quantity</div>
              </div>
              <div class="text-center">
                {{sku.quantity}}
              </div>

            </div>
            <div class="total">
              <div class="variation--label">
                <div class="label">Total</div>
              </div>
              <div>
                <span class="price font-weight-normal"><app-currency-price [price]="getVariationTotal(sku)" [currency]="product.currency"></app-currency-price></span>
              </div>
            </div>
        </div>
    </div>
</ng-template>
